import { take, call, put, fork, cancel, cancelled, select } from 'redux-saga/effects'
import { push } from 'react-router-redux'

import { ERROR, pending } from '../../state/progress/progressActions'
import { loginResponse, logout, LOGIN_REQUST, LOGOUT, LOGIN_REDIRECT, RESTORE_LOGIN } from './loginActions'
import { getAllDocuments } from '../documents/documentActions'
import { getLogin } from './loginReducer'
import progressSaga from '../progress/progressSaga'
import sagaFetch from '../sagaFetch'
import moment from 'moment'


function* startSession(couchUrl, username, password) {
  return yield fetch(`${couchUrl}/_session`, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    body: JSON.stringify({ name: username, password })
  }).then((response) => {
    return response.json()
  })
}

function* getSession(couchUrl) {
  return yield fetch(`${couchUrl}/_session`, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    method: 'GET'
  }).then((response) => {
    return response.json()
  })
}

function* getUser(couchUrl, session) {
  const { name, roles } = session
  if (roles.includes('_admin')) {
    return yield {
      db: 'master',
      name,
      roles
    }
  }
  else {
    return yield sagaFetch(`${couchUrl}/_users/org.couchdb.user:${name}`)
  }
}

export const sagas = {
  [LOGIN_REQUST]: progressSaga((action) => [LOGIN_REQUST],
    function* (args, action) {
      const { iisUrl, couchUrl } = args
      const { username, password } = action.payload
      try {

        const session = yield startSession(couchUrl, username, password)
        if (session.ok) {
          var user
          var account
          var countryCodes

          if (session.roles.includes('_admin')) {
            user = { name: username, _id: "admin" }
            var {docs} = yield call(sagaFetch, `${couchUrl}/master/_find`, { 
              method: 'POST',
              body: { selector: {type: 'account', name: 'Comtax' }}
            })        
            account = docs[0]
            const { rows: countries } = yield sagaFetch(`${couchUrl}/master/_design/country/_view/all`)
            countryCodes = countries.map((row) => row.id)
            
          } else {
            user = yield getUser(couchUrl, session)
            account = yield sagaFetch(`${couchUrl}/${user.db}/${user.accountId}`)
            countryCodes = account.license.countries            
          }

          yield sagaFetch(`${iisUrl}/Account/LoginHandler.ashx/login`,
              {
                body: {
                  userName: user.name,
                  userId: user._id,
                  accountName: account.name,
                  accountId: account._id,
                  loginTime: moment().format('YYYY-MM-DDTHH:MM:ss.SSSZ'),
                  password, 
                  countries: countryCodes,
                  roles: session.roles
                },
                credentials: 'include',
                headers: { 'Access-Control-Allow-Origin': '*' },
                method: 'POST'
              })

        }

        yield put(pending(true, LOGIN_REDIRECT))
        yield put(push('/'))
        window.location.replace('/')
      } catch (error) {
        throw { name: 'Login error', reason: 'Invalid user and/or password', raw: error }
      } finally {
        if (yield cancelled()) {
          throw { name: 'Login error', reason: 'Login cancelled' }
        }
      }
    }),
  [RESTORE_LOGIN]: progressSaga((action) => [RESTORE_LOGIN],
    function* (args, action) {
      const { couchUrl } = args
      try {
        const session = yield getSession(couchUrl);
        const { ok } = session
        if (!ok) {
          throw { name: 'SessionError', reason: 'No user session found' }
        }
        const user = yield getUser(couchUrl, session.userCtx)
        yield put(loginResponse(user))
        yield put(getAllDocuments(["account", "country", "continent", "dac6", "futureTaxRates", "note", "taxCalendar"]))
      } catch (e) {
        throw { name: 'SessionError', reason: e }
      }
    }),
  [LOGOUT]: progressSaga((action) => [LOGOUT],
    function* ({ iisUrl, couchUrl }, action) {
      try {

        yield call(sagaFetch, `${couchUrl}/_session`,
          {
            body: {},
            method: 'DELETE'
          }),
          yield call(sagaFetch, `${iisUrl}/Account/LoginHandler.ashx/logout`,
            {
              body: {},
              method: 'POST'
            })
      } catch (e) {
        log.error(e)
      }
      yield put(push('/Account/Login.html'))
      window.location.replace('/Account/Login.html')
    }),
  [ERROR]: function* (state, action) {
    const { error, path } = action.payload
    if (path[0] === LOGIN_REQUST ||
      (error && (error.status === 401 || error.name === 'SessionError'))) {
      yield put(logout())
    }
  }
}

export default function* loginSaga(sagaArgs) {
  while (true) {
    const action = yield take([LOGIN_REQUST, RESTORE_LOGIN, LOGOUT])
    const user = yield select(getLogin)
    if (action.type === LOGIN_REQUST && !user.isAuthenticated) {
      var loginTask = yield fork(sagas[LOGIN_REQUST], sagaArgs, action)
    } else if (action.type === LOGOUT) {
      if (typeof loginTask !== 'undefined') {
        yield cancel(loginTask)
      }
      yield call(sagas[LOGOUT], sagaArgs, action)
    } else if (action.type === RESTORE_LOGIN) {
      yield* sagas[RESTORE_LOGIN](sagaArgs, action)
    }
  }
}
